export default {
  data() {
    return {
      isMouseDown: false,
      tableElement: null,
      scrollLeft: 0,
      startX: 0,
      offsetLeft: 0,
    }
  },
  methods: {
    attachEventListeners() {
      this.tableElement.addEventListener('scroll', this.onScroll)
      this.tableElement.addEventListener('mousedown', this.handleMouseDown)
      this.tableElement.addEventListener('mouseup', this.handleMouseUp)
      this.tableElement.addEventListener('mousemove', this.handleMouseMove)
      this.tableElement.addEventListener('mouseleave', this.handleMouseLeave)
    },

    removeEventListeners() {
      this.tableElement.removeEventListener('scroll', this.onScroll)
      this.tableElement.removeEventListener('mousedown', this.handleMouseDown)
      this.tableElement.removeEventListener('mouseup', this.handleMouseUp)
      this.tableElement.removeEventListener('mousemove', this.handleMouseMove)
      this.tableElement.removeEventListener('mouseleave', this.handleMouseLeave)
    },

    handleMouseDown(e) {
      this.isMouseDown = true
      this.startX = e.pageX - this.tableElement.offsetLeft
      this.scrollLeft = this.tableElement.scrollLeft
    },
    handleMouseUp(_e) {
      this.isMouseDown = false
      this.tableElement.classList.remove('active')
    },

    handleMouseMove(e) {
      if (!this.isMouseDown) return
      e.preventDefault()
      const x = e.pageX - this.tableElement.offsetLeft
      const walk = x - this.startX
      const newScrollLeft = Math.max(this.scrollLeft - walk, 0)
      this.tableElement.scrollLeft = newScrollLeft
    },

    handleMouseLeave(_e) {
      this.isMouseDown = false
    },

    onScroll(e) {
      const leftPosition = e.target.scrollLeft
      this.$emit('left', leftPosition)
    },
  },
}
